import { lienPriorityApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LIEN_PRIORITIES_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/lienPriorities`,
  {
    GET_USED_LIEN_PRIORITIES: 'GET_USED_LIEN_PRIORITIES',
  },
);

export const getUsedLienPrioritiesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await lienPriorityApi.getUsedLienPriorities(params);

  return dispatch({
    type: LIEN_PRIORITIES_ACTION_TYPE.GET_USED_LIEN_PRIORITIES,
    payload: data,
  });
});
